// The Giant's calendar: one 101x101 a season (Matt, 2026-10-18: "You could
// make one per month? Per three months?"). Meteorological seasons, as the
// calendar months: winter is December-February and is named for the year
// its December falls in. Pure, shared by the generator and the player.
//
//   seasonOf('2026-10-19') -> { id: '2026-fall', name: 'Fall 2026',
//                               startsOn: '2026-09-01', giantId: 'giant-2026-fall' }
const SEASONS = [
  { key: 'winter', label: 'Winter', months: [12, 1, 2] },
  { key: 'spring', label: 'Spring', months: [3, 4, 5] },
  { key: 'summer', label: 'Summer', months: [6, 7, 8] },
  { key: 'fall', label: 'Fall', months: [9, 10, 11] },
];

export const GIANT_PREFIX = 'giant-';

const pad = (m) => String(m).padStart(2, '0');

function make(year, season) {
  const id = `${year}-${season.key}`;
  const name = season.key === 'winter' ? `${season.label} ${year}–${String(year + 1).slice(2)}` : `${season.label} ${year}`;
  return { id, name, startsOn: `${year}-${pad(season.months[0])}-01`, giantId: `${GIANT_PREFIX}${id}` };
}

/** The season a YYYY-MM-DD date is in. */
export function seasonOf(date) {
  const [y, m] = date.split('-').map(Number);
  const season = SEASONS.find((s) => s.months.includes(m));
  return make(season.key === 'winter' && m < 12 ? y - 1 : y, season);
}

/** A season from its id ('2026-fall'), or null. */
export function seasonById(id) {
  const match = /^(\d{4})-(winter|spring|summer|fall)$/.exec(String(id || '').replace(GIANT_PREFIX, ''));
  if (!match) return null;
  return make(Number(match[1]), SEASONS.find((s) => s.key === match[2]));
}

/** The season after one. */
export function nextSeason(season) {
  const [y, m] = season.startsOn.split('-').map(Number);
  const next = m + 3 > 12 ? `${y + 1}-${pad(m + 3 - 12)}-01` : `${y}-${pad(m + 3)}-01`;
  return seasonOf(next);
}

export const isGiantId = (id) => String(id || '').startsWith(GIANT_PREFIX);
